import { useStableCallback } from "@prismicio/editor-support/React"
import {
  type GroupContent,
  isGroupContent,
  isNestableContent,
  type NestableContent,
} from "@prismicio/types-internal/lib/content"
import type {
  Group,
  NestableWidget,
} from "@prismicio/types-internal/lib/customtypes"
import { useMemo } from "react"

import { GroupEditor } from "./GroupEditor"
import { NestableWidgetSwitch } from "./NestableWidgetSwitch"

interface Props {
  content: NestableContent | GroupContent | undefined
  id: string
  widget: NestableWidget | Group
  onContentChange: (content: NestableContent | GroupContent | undefined) => void
  readOnly: boolean
}

export function GroupAndNestableWidgetSwitch(props: Props) {
  const { id, readOnly, content, widget } = props

  const onContentChange = useStableCallback(props.onContentChange)

  return useMemo(() => {
    const fieldProps = { id, readOnly, onContentChange }

    if (widget.type === "Group") {
      return (
        <GroupEditor
          {...fieldProps}
          group={widget}
          content={isGroupContent(content) ? content : undefined}
        />
      )
    } else {
      return (
        <NestableWidgetSwitch
          {...fieldProps}
          nestableWidget={widget}
          content={isNestableContent(content) ? content : undefined}
        />
      )
    }
  }, [content, id, widget, onContentChange, readOnly])
}
